module.exports = __webpack_public_path__ + "media/images/emblems/Ferenbalm-coat_of_arms-3f3c98457242f80973a349a321234d9b.svg";